import { Container, Stack, Typography } from '@mui/material';
import { Routes } from 'enums';
import PaiLink from 'features/ui/base-components/pai-link';
import { useExtensionAuth } from 'hooks/use-extension-auth';
import { useUserData } from 'hooks/use-user-data';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useNavigate } from 'react-router';
import { Shadows } from 'theme';
import { makeStyles } from 'tss-react/mui';
import PaiButton from '../features/ui/base-components/pai-button';
import PaiListItem from '../features/ui/base-components/pai-list-item';

const ExtensionInstallationSuccess: React.FC = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { token } = useUserData();
  const { extensionSignInStoredValues } = useExtensionAuth();
  const navigate = useNavigate();
  const { isAuthenticated } = useUserData();
  const authenticated = isAuthenticated();

  const linkedInUrl = 'https://www.linkedin.com/in/simon-tschuertz/';

  useEffect(() => {
    extensionSignInStoredValues();
  }, [token]);

  const handleOpenLinkedin = () => {
    window.open(linkedInUrl, '_blank');
  };

  return (
    <Container className={classes.container} style={{ maxWidth: '1920px' }}>
      <div className={classes.extensionInstallationSuccess}>
        <div className={classes.paper}>
          <div className={classes.titleContainer}>
            <Typography className={classes.title}>SAIA</Typography>
            <Typography className={classes.title}>{t('extensionInstallationSuccessTitle')}</Typography>
          </div>
          <div className={classes.content}>
            <Stack gap={2.5}>
              <Stack gap={2}>
                <Typography className={classes.subTitle}>{t('extensionInstallationSuccess1')}</Typography>
                <Stack gap={0.5}>
                  <PaiListItem text={t('extensionInstallationSuccess2')} />
                  <PaiListItem text={t('extensionInstallationSuccess3')} />
                  <PaiListItem text={t('extensionInstallationSuccess4')} />
                  <PaiListItem text={t('extensionInstallationSuccess5')} />
                  {authenticated ? (
                    <RouterLink className={classes.link} to={Routes.UPGRADE} target={'_blank'}>
                      <PaiLink text={t('paidModels')} variant={'primary'} underline={'always'} size={'sm'} ml={'18px'} mb={'4px'} />
                    </RouterLink>
                  ) : null}
                </Stack>
                <PaiButton text={t('openLinkedIn')} action={handleOpenLinkedin} size={'large'} />
              </Stack>
              <Stack direction={'row'} justifyContent={'center'}>
                <PaiLink text={t('backToDashboard')} variant={'primary'} underline={'always'} size={'sm'} action={() => navigate(Routes.SIGNIN)} />
              </Stack>
            </Stack>
          </div>
        </div>
      </div>
    </Container>
  );
};

const useStyles = makeStyles()((theme) => ({
  container: {
    paddingTop: '48px',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      margin: 0,
    },
  },
  extensionInstallationSuccess: {
    display: 'flex',
    justifyContent: 'center',
  },
  paper: {
    boxShadow: Shadows.GREY_SHADOW_LIGHT,
    width: '100%',
    maxWidth: '450px',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'unset',
      boxShadow: 'unset',
    },
  },
  titleContainer: {
    width: '100%',
    padding: '24px',
    backgroundColor: theme.palette.primary.main,
    backgroundImage: 'url(/dashboard/images/logos/product_logo_white.svg)',
    backgroundSize: 'auto 80%',
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'calc(100% - 12px)',
    backgroundPositionY: 'center',
  },
  title: {
    color: '#FFF',
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 'bold',
  },
  content: {
    padding: '20px 24px',
  },
  subTitle: {
    fontSize: theme.typography.pxToRem(16),
  },
  link: {
    textDecoration: 'none',
  },
}));

export default ExtensionInstallationSuccess;
